
import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import ListCart from './ListCart.vue';
import Paging from '@/shared/components/Paging.vue';

import { Cart } from '@/models/cart';
import { Product } from '@/models/product';

import commonService from '@/services/common-services';
import cartServices from '@/services/cart-services';
import { APP_CONFIG } from '@/config/app-config';
@Component({
  components: {
    ListCart,
    Paging,
    Loading,
  },
})
export default class MainCart extends Vue {
    private pageSettings = {
      rowPerPage: 1000,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private selectedAll = false;
    private listCart: Cart[] = [];
    private isLoading = false;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get amountGoods() {
      return this.shopSelected.reduce((amount: number, cart: Cart) => {
        return amount + cart.products.filter(x => x.isChoose === true).reduce((amountPro, prod: Product) => {
          return amountPro + prod.amount;
        }, 0);
      }, 0);
    }

    get totalProduct() {
      return this.shopSelected.reduce((total: number, cart: Cart) => {
        return total + cart.products.filter(x => x.isChoose === true).length;
      }, 0);
    }

    get shopSelected() {
      return this.listCart.filter(x => x.isChoose === true);
    }

    private async created() {
      this.isLoading = true;
      if (!this.rate) {
        await this.getRate();
      }
      await this.getListCart();
      this.isLoading = false;
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private async getListCart() {
      this.listCart = [];
      this.pageSettings.total = 0;
      const result = await cartServices.cartList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, '');
      if (result && result.status === 200) {
        const data = result.data.data;
        this.pageSettings.total = result.data.total;
        for (const item of data) {
          const cart = new Cart();
          cart.createDate = item.CreatedDate;
          cart.id = item.ID;
          cart.isFeeShip = item.IsFeeShip ? item.IsFeeShip : 0;
          cart.isFragileGoods = item.IsFragileGoods ? item.IsFragileGoods : 0;
          cart.note = item.Note;
          cart.shopId = item.ShopID;
          cart.shopName = item.ShopName;
          cart.site = item.Site;
          cart.uId = item.UID;
          cart.products = [];
          cart.isLoading = false;
          cart.isChoose = false;

          for (const prod of item.Products) {
            const product = new Product();
            product.id = prod.ID;
            product.comment = prod.comment;
            product.imageOrigin = prod.image_origin;
            product.linkOrigin = prod.link_origin;
            product.priceOrigin = prod.price_origin;
            product.pricePromotion = prod.price_promotion;
            product.priceOriginVND = product.priceOrigin * this.rate;
            product.pricePromotionVND = product.pricePromotion * this.rate;
            product.property = prod.property;
            product.quantity = prod.quantity;
            product.titleOrigin = prod.title_origin;
            product.dataValue = prod.data_value;
            product.itemId = prod.item_id;
            product.amount = (prod.quantity || 1) * ((prod.price_promotion || prod.price_origin) * this.rate);
            product.amountCN = (prod.quantity || 1) * (prod.price_promotion || prod.price_origin);
            product.isChoose = false;
            cart.products.push(product);
          }

          cart.amount = cart.products.reduce((val, product) => {
            return val + product.amount;
          }, 0);
          

          this.listCart.push(cart);
        }
      }
    }

    private async onQuantityChange(dataEvent: any) {

      const eventProduct = dataEvent.cartItem.products[dataEvent.productIndex];
      const dataRequest = {
        ID: dataEvent.cartItem.id,
        Products: [
          {
            ID: eventProduct.id,
            quantity: (Number)(eventProduct.quantity),
          },
        ],
      };

      const result: any = await cartServices.cartEdit(dataRequest, dataEvent.cartItem.id);
      if (result.data.status === 200 && result.data.message === 'Success') {
        this.listCart = this.listCart.filter((cart) => {
          if (cart.id === dataEvent.cartItem.id) {
            cart.isLoading = false;

            const product = cart.products[dataEvent.productIndex];
            product.quantity = (Number)(eventProduct.quantity || 1);
            product.amount = product.quantity * ((Number)(product.pricePromotion || product.priceOrigin) * this.rate);
            product.amountCN = product.quantity * (Number)(product.pricePromotion || product.priceOrigin);
            cart.products[dataEvent.productIndex] = product;

            cart.amount = cart.products.reduce((val, prod) => {
              return val + prod.amount;
            }, 0);
          }
          return cart;
        });
      }
    }

    private async onFeeShipChange(dataEvent: any) {
      const dataRequest = {
        ID: dataEvent.cartItem.id,
        IsFeeShip: dataEvent.cartItem.isFeeShip,
        Products: [],
      };

      const result: any = await cartServices.cartEdit(dataRequest, dataEvent.cartItem.id);
      this.listCart = this.listCart.filter((cart) => {
        if (cart.id === dataEvent.cartItem.id) {
          cart.isLoading = false;
        }
        return cart;
      });
    }

    private async onFragileGoodsChange(dataEvent: any) {
      const dataRequest = {
        ID: dataEvent.cartItem.id,
        IsFragileGoods: dataEvent.cartItem.isFragileGoods,
        Products: [],
      };

      const result: any = await cartServices.cartEdit(dataRequest, dataEvent.cartItem.id);
      this.listCart = this.listCart.filter((cart) => {
        if (cart.id === dataEvent.cartItem.id) {
          cart.isLoading = false;
        }
        return cart;
      });
    }

    private async onCommentChange(dataEvent: any) {
      const eventProduct = dataEvent.cartItem.products[dataEvent.productIndex];
      const dataRequest = {
        ID: dataEvent.cartItem.id,
        Products: [
          {
            ID: eventProduct.id,
            comment: eventProduct.comment,
          },
        ],
      };

      const result: any = await cartServices.cartEdit(dataRequest, dataEvent.cartItem.id);
      if (result.data.status === 200 && result.data.message === 'Success') {
        this.listCart = this.listCart.filter((cart) => {
          if (cart.id === dataEvent.cartItem.id) {
            cart.isLoading = false;

            const product = cart.products[dataEvent.productIndex];
            product.comment = eventProduct.comment;
          }
          return cart;
        });
      }
    }

    private async onChangeDescription(dataEvent: any) {
      const dataRequest = {
        ID: dataEvent.cartItem.id,
        Note: dataEvent.cartItem.note,
        Products: [],
      };

      const result: any = await cartServices.cartEdit(dataRequest, dataEvent.cartItem.id);
      this.listCart = this.listCart.filter((cart) => {
        if (cart.id === dataEvent.cartItem.id) {
          cart.isLoading = false;
        }
        return cart;
      });
    }

    private async onDeleteItem(dataEvent: any) {
      const eventProduct = dataEvent.cartItem.products[dataEvent.productIndex];

      const result: any = await cartServices.cartRemoveItem(eventProduct.id);
      if (result.data.status === 200 && result.data.message === 'Success') {
        this.listCart = this.listCart.filter((cart) => {
          if (cart.id === dataEvent.cartItem.id) {
            const extantProd = cart.products.filter((product) => product.id !== eventProduct.id);
            cart.isLoading = false;
            cart.isChoose = extantProd.filter(prod => prod.isChoose === true).length > 0 ? true : false;
            cart.products = extantProd;
            cart.amount = cart.products.reduce((val, product) => {
              return val + product.amount;
            }, 0);
          }
          return cart;
        });
        this.listCart = this.listCart.filter((cart) => cart.products.length > 0);
      }
    }

    private async onDeleteCart(dataEvent: any) {
        const result: any = await cartServices.cartRemove(dataEvent.cartItem.id);
        if (result.data.status === 200 && result.data.message === 'Success') {
          this.listCart = this.listCart.filter((cart) => cart.id !== dataEvent.cartItem.id);
        }
    }

    private async onCartRemoveProducts() {
      this.isLoading = true;
      const shopIds: number[] =  this.shopSelected.reduce((items: any, cart: Cart) => {
        const ret = cart.products.filter(prod => prod.isChoose !== true).length;
        if(ret === 0) {
          items = items.concat(cart.id);
        }
        return items;
      }, []);
      const itemIds: number[] =  this.shopSelected.reduce((items: any, cart: Cart) => {
        return !shopIds.includes(cart.id) ? items.concat(cart.products.filter(prod => prod.isChoose === true).map(prod => prod.id)) : items;
      }, []);

      await cartServices.cartRemoveCarts(shopIds);
      const result: any = await cartServices.cartRemoveProducts(itemIds);
      this.isLoading = false;
      if(result && result.data.status === 200 && result.data.message === 'Success') {
        this.listCart = this.listCart.map(cart => {
          const extantProd = cart.products.filter(prod => itemIds.filter(x => x === prod.id).length === 0);
          return {
            ...cart,
            products: extantProd,
            isChoose: false
          }
        }).filter(cart => cart.products.length > 0 && !shopIds.includes(cart.id));
      }

    }

    private async onChooseCart(dataEvent: any) {
      this.listCart = this.listCart.filter((cart) => {
        if (cart.id === dataEvent.cartItem.id) {
          cart.isChoose = dataEvent.cartItem.isChoose;
          cart.products = cart.products.map((product) => {
            product.isChoose = dataEvent.cartItem.isChoose;
            return product;
          });
        }
        return cart;
      });

      this.checkSelectAll();
    }

    private async onChooseProduct(dataEvent: any) {
      this.listCart = this.listCart.filter((cart) => {
        if (cart.id === dataEvent.cartId) {
          cart.products = cart.products.map((product) => {
            if (product.id === dataEvent.product.id) {
              product.isChoose = dataEvent.product.isChoose;
            }
            return product;
          });

          cart.isChoose = cart.products.filter(x => x.isChoose === true).length > 0 ? true : false;
        }
        return cart;
      });

      this.checkSelectAll();
    }

    private onChangeSelectAll() {
      this.listCart = this.listCart.map(cart => {
        return {
          ...cart,
          isChoose: this.selectedAll,
          products: cart.products.map(prod => {
            return {
              ...prod,
              isChoose: this.selectedAll,
            }
          }),
        };
      });
    }

    private checkSelectAll() {
      this.selectedAll = this.listCart.reduce((x: number, cart: Cart) => {
        return x + cart.products.filter(p => p.isChoose === false).length;
      }, 0) > 0 ? false : true;
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.getListCart();
    }

    private pickupCart() {
      if (this.shopSelected.length > 0) {
        const emitData = this.shopSelected.map(cart => {
          const cartReturn = {
            ...cart,
            products: cart.products.filter(x => x.isChoose === true)
          };
          
          // if (cartReturn.products.length > 150) {
          //   const tempCartReturn = {
          //     ...cartReturn,
          //     products: cartReturn.products.slice(150)
          //   };
          //   cartReturn.products = cartReturn.products.slice(0, 150)
          //   return [cartReturn, tempCartReturn];
          // }
          return cartReturn;
        });

        (window['getApp'] as any).$emit('SET_SELECTED_CART', emitData.flat());
        this.$router.push({ name: 'cart-confirm-cart' });
      } else {
        Vue.notify({
          group: 'foo',
          type: 'error',
          title: 'Thông báo!',
          text: 'Hãy chọn sản phẩm cần đặt hàng!',
        });
        (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
      }
      

    }

    private orderCart() {
      this.$router.push({
        name: 'cart-confirm-cart',
        params: {
          cartIds: this.listCart.reduce((x, cart) => {
            return (x === '' ? cart.id.toString() : x + `,${cart.id}`);
          }, ''),
        },
      });
    }

}
